// extracted by mini-css-extract-plugin
export default {"container":"about_container__w7QPj","title":"about_title__kQtPG","summary":"about_summary__fywpi"};